import { css, genesisStyled } from '@leagueplatform/genesis-commons';
import React, { useState } from 'react';
import { useIntl } from '@leagueplatform/locales';
import {
  Box,
  ParagraphText,
  StackLayout,
  TextAction,
} from '@leagueplatform/genesis-core';
import { LegalModal } from './legal-modal.component';

const DisclaimerContent = genesisStyled(Box)(
  css({
    '&& > *': {
      marginBottom: 'one',
    },
    '&& > :last-child': {
      marginBottom: '0',
    },
  }),
);

const UnstyledLinkButton = ({
  onClick,
  children,
}: {
  onClick: () => void;
  children: any;
}) => (
  <TextAction
    as="button"
    size="medium"
    emphasis="subtle"
    onClick={onClick}
    css={{
      backgroundColor: 'transparent !important',
      border: 'none',
      fontSize: '$bodyTwo',
      fontWeight: '$label',
      color: '$tertiaryTextDefault',
      '&:hover': {
        textDecoration: 'none',
        color: '$tertiaryTextHovered',
      },
    }}
  >
    {children}
  </TextAction>
);

export const Disclaimer = ({
  disclaimer = '',
  hasLegalModal = false,
}: {
  disclaimer?: string;
  hasLegalModal?: boolean;
}) => {
  const { formatMessage } = useIntl();
  const [showLegalModal, setShowModal] = useState<Boolean>(false);

  return (
    <StackLayout>
      <DisclaimerContent>
        {disclaimer
          .split('\n')
          .filter((text) => text !== '') // Remove any empty strings, sometimes there's double /n in text.
          .map((text) => (
            <ParagraphText size="sm" key={text}>
              {text}
            </ParagraphText>
          ))}
        {hasLegalModal && (
          <UnstyledLinkButton onClick={() => setShowModal(true)}>
            {formatMessage({ id: 'READ_MORE' })}
          </UnstyledLinkButton>
        )}
      </DisclaimerContent>
      {hasLegalModal && (
        <LegalModal
          isOpen={showLegalModal}
          onClose={() => setShowModal(false)}
        />
      )}
    </StackLayout>
  );
};
